import React from 'react'

const UserIcon = () => {
    return (
        <div>
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 0C23.7848 0 26.4555 1.10625 28.4246 3.07537C30.3937 5.04451 31.5 7.71522 31.5 10.5C31.5 13.2848 30.3937 15.9555 28.4246 17.9246C26.4555 19.8937 23.7848 21 21 21C18.2152 21 15.5445 19.8937 13.5754 17.9246C11.6063 15.9555 10.5 13.2848 10.5 10.5C10.5 7.71522 11.6063 5.04451 13.5754 3.07537C15.5445 1.10625 18.2152 0 21 0ZM21 26.25C32.6025 26.25 42 30.9487 42 36.75V42H0V36.75C0 30.9487 9.3975 26.25 21 26.25Z" fill="#475969" />
            </svg>
        </div>
    )
}

export default UserIcon
